import React, { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import GeographicalComponent from "../../../components/GeographicalComponent/GeographicalComponent";

import {
  FaCalendarAlt,
  FaUniversity,
  FaCreditCard,
  FaBuilding,
  FaMobileAlt,
  FaBarcode,
  FaToggleOn,
  FaMapMarkerAlt,
} from "react-icons/fa";

const BankUpdateChild = ({ selectedBank }) => {
  let navigate = useNavigate();
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid #e2e8f0",
      borderRadius: "0.375rem",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #4299e1",
      },
    }),
  };

  const [{ errorLogApi, placeHolderText }] = useAtom(gbState);
  const [formData, setFormData] = useState({
    bank_name: selectedBank?.bank_name,
    account_number: selectedBank?.account_number,
    account_type: selectedBank?.account_type,
    branch: selectedBank?.branch,
    active_status: selectedBank?.active_status,
    date_of_opening: selectedBank?.date_of_opening,
    upi_id: selectedBank?.upi_id,
    routing_number: selectedBank?.routing_number,
    ifsc_code: selectedBank?.ifsc_code,
    swift_code: selectedBank?.swift_code,
    payment_gateway_status: selectedBank?.payment_gateway_status,
    bank_zipcode: selectedBank?.bank_zipcode,
    city: selectedBank?.city,
    state: selectedBank?.state,
    country: selectedBank?.country,
    bank_address: selectedBank?.bank_address,
  });

  const handleBankUpdate = (e) => {
    e.preventDefault();
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/banks/update/${selectedBank?._id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };
    axios(config)
      .then(function (response) {
        toast.success("Bank Updated Successfully.");
        navigate("/banks");
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "UpdateBankChild", "/bank/update");
      });
  };

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const accountTypeOptions = [
    { value: 1, label: "Current" },
    { value: 2, label: "Savings" },
  ];

  const accountStatusOptions = [
    { value: true, label: "Enable" },
    { value: false, label: "Disable" },
  ];

  return (
    <div className="max-w-4xl p-6 mx-auto">
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">Update Bank</h2>
      <form onSubmit={(e) => handleBankUpdate(e)} autoComplete="off">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Bank Name
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="bank_name"
                type="text"
                required
                placeholder="Bank Name"
                onChange={handleChange}
                value={formData.bank_name}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaUniversity className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div className="">
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Swift Code
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="swift_code"
                type="text"
                required
                placeholder="Swift Code"
                onChange={handleChange}
                value={formData.swift_code}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaBarcode className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Account Number
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="account_number"
                type="text"
                required
                placeholder="Account Number"
                onChange={handleChange}
                value={formData.account_number}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaCreditCard className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Account Type
            </label>
            <div className="relative">
              <Select
                name="account_type"
                onChange={(selected) => {
                  setFormData({
                    ...formData,
                    account_type: selected.label,
                  });
                }}
                options={accountTypeOptions}
                value={
                  formData?.account_type &&
                  accountTypeOptions?.find(
                    (at) => at.label === formData.account_type
                  )
                }
                placeholder={placeHolderText("Select Account Type")}
                styles={{
                  ...style,
                  control: (provided) => ({
                    ...provided,
                    paddingLeft: "2.5rem",
                  }),
                }}
              />
              <div className="absolute inset-y-0 left-0 z-10 flex items-center pl-3 pointer-events-none">
                <FaBuilding className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Date of Opening
            </label>
            <DatePicker
              className="w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              name="date_of_opening"
              onChange={(date) => {
                setFormData({
                  ...formData,
                  date_of_opening: date,
                });
              }}
              showToday={true}
              placeholder="Select Date"
              format="MM-DD-YYYY"
              defaultValue={
                formData?.date_of_opening && dayjs(formData?.date_of_opening)
              }
              suffixIcon={<FaCalendarAlt className="text-gray-400" />}
            />
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Routing Number
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="routing_number"
                type="text"
                required
                placeholder="Enter Routing Number"
                onChange={handleChange}
                value={formData.routing_number}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaMobileAlt className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Bank Street
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="bank_address"
                type="text"
                required
                placeholder="Street"
                onChange={handleChange}
                value={formData.bank_address}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaBuilding className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>

          <div className="">
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Zip Code
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="bank_zipcode"
                type="text"
                required
                placeholder="zip Code"
                onChange={handleChange}
                value={formData.bank_zipcode}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaMapMarkerAlt className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          {/* <div className="">
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Zip Code
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="bank_zipcode"
                type="text"
                required
                placeholder="zip Code"
                onChange={handleChange}
                value={formData.bank_zipcode}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaMapMarkerAlt className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Swift Code
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="swift_code"
                type="text"
                required
                placeholder="Swift Code"
                onChange={handleChange}
                value={formData.swift_code}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaBarcode className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div> */}
        </div>
        <div className="mt-5">
          <GeographicalComponent
            setFormData={setFormData}
            formData={formData}
            handleChange={handleChange}
            dropDownChange={dropDownChange}
            style={style}
            placeHolderText={placeHolderText}
          />
        </div>
        <div className="mt-5">
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Account Status
          </label>
          <div className="relative">
            <Select
              name="active_status"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  active_status: selected.value,
                });
              }}
              options={accountStatusOptions}
              value={accountStatusOptions?.find(
                (at) => at.value === formData.active_status
              )}
              placeholder={placeHolderText("Select Account Status")}
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  paddingLeft: "2.5rem",
                }),
              }}
            />
            <div className="absolute inset-y-0 left-0 z-10 flex items-center pl-3 pointer-events-none">
              <FaToggleOn className="w-5 h-5 text-gray-400" />
            </div>
          </div>
        </div>
        <div className="flex items-center mt-6">
          <input
            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
            name="payment_gateway_status"
            type="checkbox"
            checked={formData.payment_gateway_status}
            disabled={!formData.upi_id}
            onChange={(e) => {
              setFormData({
                ...formData,
                payment_gateway_status: e.target.checked,
              });
            }}
          />
          <label className="block ml-2 text-sm font-medium text-gray-700">
            Select for Payment Gateway
          </label>
        </div>
        <div className="flex justify-end mt-8 space-x-4">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            type="submit"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default BankUpdateChild;
